// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_container__6VngY","curt":"modal_curt__2OOdr"};